export const getApiUrl = () => {
  const API_URL = process.env.REACT_APP_API_URL;
  const BASE_PATH = process.env.REACT_APP_BASE_PATH;
  return `${API_URL}${BASE_PATH}`;
};

export const getBestRole = (user) => {
  const roleValues = {
    Admin: 3,
    Validator: 2,
    Coordinator: 1,
  };

  const highestRole = user?.userRoles.reduce((highest, role) => {
    return roleValues[role.roleName] > roleValues[highest.roleName]
      ? role
      : highest;
  }, user?.userRoles[0]);

  return highestRole.roleName;
};

export const formatDateInItalian = (cell) => {
  const value = cell.getValue();
  if (!value) return ""; // Gestisce i valori null o undefined
  const date = new Date(value);
  return date.toLocaleDateString("it-IT", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export const formatDateInItalianFromDateObject = (isoString) => {
  if (!isoString) return ""; // Gestisce i valori null o undefined
  const date = new Date(isoString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};